import {login} from "./auth"
import { baseUrl } from "./consts"
import { intitutRoutes, missionsRoutes,espacesRoutes } from "./apiRoutes"

export  async function fetchAPIInstitut(region) {
    var response = await login();
  if (response.ok) {
    console.log(region)
    var route  = `${baseUrl}${intitutRoutes.filter(x=>x.region===region)[0].url}`;
    console.log(route)
      var data = await response.json();
      console.log(data)
      const res = await fetch(route, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization":"Bearer "+data['access_token']
        },
        
      });
  
      const json = await res.json();
    
      if (json.errors) {
        console.error(json.errors);
        throw new Error("Failed to fetch API");
      }
      console.log(json);
      return json;
    }
    }
  
    export  async function fetchAPIInstitutDetails(region,$id) {
      const response=await fetch("https://altadmin.if-algerie.com/identity-server/connect/token",{
        contentType: "application/x-www-form-urlencoded",
        body: new URLSearchParams({
            grant_type: "client_credentials",
            client_id: "ifa:default",
            client_secret: "iwruhktybm9nci4efz2okuwibldlottkxgztjgfgbnux",
            scope: "squidex-api",
        }),
        method: "POST",
    });
    if (response.ok) {
        var data = await response.json();
        console.log(data)
        const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/institut-presentation/"+$id, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization":"Bearer "+data['access_token']
          },
          
        });
    
        const json = await res.json();
      
        if (json.errors) {
          console.error(json.errors);
          throw new Error("Failed to fetch API");
        }
        console.log(json);
        return json;
      }
      }

      export  async function fetchAPIMissionsRegion(region) {
        console.log(region)
        var response = await login();
      if (response.ok) {
          var data = await response.json();
          missionsRoutes.map((e)=>console.log(`${e.region.toString()}`))
          const res = await fetch(`${baseUrl}${missionsRoutes.filter(x=>x.region===region)[0]?.url}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization":"Bearer "+data['access_token']
            },
            
          });
      
          const json = await res.json();
        
          if (json.errors) {
            console.error(json.errors);
            throw new Error("Failed to fetch API");
          }
          console.log(json);
          return json;
        }
        }

        export  async function fetchAPIRecrutement(region) {
          const response=await fetch("https://altadmin.if-algerie.com/identity-server/connect/token",{
            contentType: "application/x-www-form-urlencoded",
            body: new URLSearchParams({
                grant_type: "client_credentials",
                client_id: "ifa:default",
                client_secret: "iwruhktybm9nci4efz2okuwibldlottkxgztjgfgbnux",
                scope: "squidex-api",
            }),
            method: "POST",
        });
        if (response.ok) {
            var data = await response.json();
            console.log(data)
            const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/recrutement", {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer "+data['access_token']
              },
              
            });
        
            const json = await res.json();
          
            if (json.errors) {
              console.error(json.errors);
              throw new Error("Failed to fetch API");
            }
            console.log(json);
            return json;
          }
          }
          export  async function fetchAPIEspacesRegion(region) {
            const response=await login();
          if (response.ok) {
              var data = await response.json();
              console.log(data)
              const res = await fetch(`${baseUrl}${espacesRoutes.filter(x=>x.region===region)[0].url}`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization":"Bearer "+data['access_token']
                },
                
              });
          
              const json = await res.json();
            
              if (json.errors) {
                console.error(json.errors);
                throw new Error("Failed to fetch API");
              }
              console.log(json);
              return json;
            }
            }
            export  async function fetchAPIProjects() {
              const response=await fetch("https://altadmin.if-algerie.com/identity-server/connect/token",{
                contentType: "application/x-www-form-urlencoded",
                body: new URLSearchParams({
                    grant_type: "client_credentials",
                    client_id: "ifa:default",
                    client_secret: "iwruhktybm9nci4efz2okuwibldlottkxgztjgfgbnux",
                    scope: "squidex-api",
                }),
                method: "POST",
            });
            if (response.ok) {
                var data = await response.json();
                console.log(data)
                const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/appels-projets", {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization":"Bearer "+data['access_token']
                  },
                  
                });
            
                const json = await res.json();
              
                if (json.errors) {
                  console.error(json.errors);
                  throw new Error("Failed to fetch API");
                }
                console.log(json);
                return json;
              }
              }
              export  async function fetchAPIBourses() {
                const response=await fetch("https://altadmin.if-algerie.com/identity-server/connect/token",{
                  contentType: "application/x-www-form-urlencoded",
                  body: new URLSearchParams({
                      grant_type: "client_credentials",
                      client_id: "ifa:default",
                      client_secret: "iwruhktybm9nci4efz2okuwibldlottkxgztjgfgbnux",
                      scope: "squidex-api",
                  }),
                  method: "POST",
              });
              if (response.ok) {
                  var data = await response.json();
                  console.log(data)
                  const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/bourses-condidatures", {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      "Authorization":"Bearer "+data['access_token']
                    },
                    
                  });
              
                  const json = await res.json();
                
                  if (json.errors) {
                    console.error(json.errors);
                    throw new Error("Failed to fetch API");
                  }
                  console.log(json);
                  return json;
                }
                }

                export  async function fetchAPIActionsCulturelles() {
                  const response=await fetch("https://altadmin.if-algerie.com/identity-server/connect/token",{
                    contentType: "application/x-www-form-urlencoded",
                    body: new URLSearchParams({
                        grant_type: "client_credentials",
                        client_id: "ifa:default",
                        client_secret: "iwruhktybm9nci4efz2okuwibldlottkxgztjgfgbnux",
                        scope: "squidex-api",
                    }),
                    method: "POST",
                });
                if (response.ok) {
                    var data = await response.json();
                    console.log(data)
                    const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/actions-culturelles", {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                        "Authorization":"Bearer "+data['access_token']
                      },
                      
                    });
                
                    const json = await res.json();
                  
                    if (json.errors) {
                      console.error(json.errors);
                      throw new Error("Failed to fetch API");
                    }
                    console.log(json);
                    return json;
                  }
                  }